/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Added on April 25, 2022 by Cynthia D at Shopify 


class CustomSearch extends HTMLElement {
  constructor() {
    super();

    this.searchBar = this.querySelector('.header-search__bar');
    this.searchButton = this.querySelector('.site-header__search');

    this.searchBar.addEventListener('keyup', this.escape.bind(this));
    this.searchButton.addEventListener('click', this.onSearchButtonClick.bind(this));
    this.querySelector('.search__close button').addEventListener('click', this.close.bind(this));

    this.searchButton.setAttribute('role', 'button');
    this.searchButton.setAttribute('aria-expanded', 'false');
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};

    this.onLoadHandler = this.initialStyle.bind(this);

    window.addEventListener('load', this.onLoadHandler, false);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.onLoadHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  initialStyle() {
    const headerHeight = document.querySelector('.site-header-sections');
    const announcementBar = document.querySelector('.announcement-bar');

    const styles = {
      top: -headerHeight - 20 + 'px',
      height: headerHeight + 'px'
    }

    Object.assign(this.searchBar.style, styles);

    if (announcementBar) {
      setTimeout(() => {
        this.searchBar.style.marginTop = announcementBar.offsetHeight + 'px';
      }, 250);
    }
  }

  isOpen() {
    return this.searchBar.hasAttribute('open');
  }

  onSearchButtonClick(event) {
    event.preventDefault();
    this.searchBar.hasAttribute('open') ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.searchBar.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.searchBar.querySelector('input').focus();
  }

  escape(event) {
    if ((event.code.toUpperCase() === 'ESCAPE') && this.searchBar.hasAttribute('open')) {
      this.close();
      this.searchButton.focus();
    }
  }

  close() {
    this.searchBar.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('custom-search', CustomSearch);

if (!Shopify.designMode) {
  const announcementClose = document.querySelector('.announcement-bar__close');
  const searchBar = document.querySelector('.header-search__bar');
  if (announcementClose && searchBar) {
    announcementClose.addEventListener('click', function() {
      searchBar.style.marginTop = '';
    })
  }
}
